import StarIcon from "@/v2-components/core/icon/star-icon";
import { useRef } from "react";

interface Props {
  rating: number;
  setRating: (rating: number) => void;
}
export default function StarSlider({ rating, setRating }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);

  const handlePointerMove = (e: React.PointerEvent<HTMLDivElement>) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;

    const gap = 20; // gap-5 = 1.25rem
    const starWidth = 48; // h-12 w-12 = 3rem = 48px
    const offsetX = e.clientX - rect.left;

    let total = 0;
    for (let i = 1; i <= 5; i++) {
      const start = total;
      const end = start + starWidth;

      if (offsetX >= start && offsetX <= end) {
        setRating(i);
        return;
      }

      total += starWidth + gap;
    }

    // 좌/우를 벗어난 경우 처리
    if (offsetX < 0) setRating(0);
    if (offsetX > total - gap) setRating(5);
  };

  const handlePointerUp = (e: React.PointerEvent<HTMLDivElement>) => {
    e.currentTarget.releasePointerCapture(e.pointerId);
  };

  const handleClick = (value: number) => {
    setRating(value);
  };

  const renderStars = () => {
    const stars: React.ReactNode[] = [];

    for (let i = 1; i <= 5; i++) {
      const isFull = i <= rating;

      stars.push(
        <div
          key={i}
          className="relative h-12 w-12 cursor-pointer"
          onClick={() => handleClick(i)}
        >
          <StarIcon className="absolute left-0 top-0 h-full w-full text-coolgray-20" />
          {isFull && (
            <StarIcon className="absolute left-0 top-0 h-full w-full text-bhaptics-yellow-hover" />
          )}
        </div>,
      );
    }
    return stars;
  };

  return (
    <div
      ref={containerRef}
      className="flex cursor-pointer touch-none select-none items-center gap-5"
      onPointerDown={handlePointerMove}
      onPointerUp={handlePointerUp}
      onPointerMove={(e) => {
        if (e.buttons === 1) handlePointerMove(e);
      }}
    >
      {renderStars()}
    </div>
  );
}
